<template>
  <div class="main">
    <Nav />
    <div class="container">
      <div class="content">
        <h1 class="title is-1">Contact us</h1>
        <p>
          For more information about Texas I-CAN! or for support in using this site, please contact us at:
          <br />Phone:
          <a href="tel:512-232-6627">512-232-6027</a>
          <br />Email:
          <a href="mailto:ican@utlists.utexas.edu">ican@utlists.utexas.edu</a>
        </p>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
export default {
  components: {
    Nav,
    Footer
  }
};
</script>

<style lang='scss'>
</style>

